<template>
    <div class="text-center sync-action">
        <b-button
            variant="success"
            size="sm"
            :disabled="syncDisabled"
            @click="syncBucket"
        >
            <b-spinner v-if="syncing" small class="mr-1"></b-spinner>
            sync {{ label }} bucket
        </b-button>

        <div v-if="stamp" class="text-secondary mt-2">
            <small>last {{ label }} sync at {{ formatTimeFromISO(stamp) }}</small>
        </div>
    </div>
</template>


<script>

import apiMixin from '@/mixins/api';
import formatterMixin from '@/mixins/formatter';

/* A finished sync holds the button for a minute, so a second press cannot pile on. Named
   apart from the SYNC_COOLDOWN_MS in constants/sync.js, which paces the price re-sync. */
const BUCKET_SYNC_COOLDOWN_MS = 60_000;

export default {
    name: 'BucketSync',
    mixins: [apiMixin, formatterMixin],
    props: {
        // answers {updated, skipped, bucket_last_check}, or {api_error} with a 200
        endpoint: {
            type: String,
            required: true,
        },
        // names the exchange in the button, the stamp and the toast
        label: {
            type: String,
            required: true,
        },
        lastCheck: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            syncedAt: null,
            syncing: false,
            cooling: false,
            cooldownTimer: null,
        }
    },
    methods: {
        startCooldown() {
            this.cooling = true;
            this.cooldownTimer = setTimeout(() => { this.cooling = false; }, BUCKET_SYNC_COOLDOWN_MS);
        },
        async syncBucket() {
            this.syncing = true;
            const response = await this.apiPost(this.endpoint);
            this.syncing = false;

            if (!response) return;

            // the route answers 200 with a reason, so the mixin raises nothing to toast
            if (response.data.api_error) {
                this._apiErrorToast(new Error(response.data.api_error));
                return;
            }

            this.syncedAt = response.data.bucket_last_check;
            this._apiSuccessToast(
                `${this.label} sync finished - ${response.data.updated} updated, ${response.data.skipped} skipped`
            );
            this.startCooldown();
        },
    },
    beforeDestroy() {
        clearTimeout(this.cooldownTimer);
    },
    computed: {
        syncDisabled() {
            return this.syncing || this.cooling;
        },
        // the stamp this component wrote outranks the one the page loaded with
        stamp() {
            return this.syncedAt || this.lastCheck;
        },
    }
}

</script>


<style scoped>
/* 2rem, double the mb-3 the surrounding containers use */
.sync-action {
    margin: 2rem 0;
}
</style>
